import {railsPartialQuery} from '@github-ui/react-core/future/rails-partial-query'
import type {DataRouterApplicationBuilder} from '@github-ui/react-core/future/data-router-application'
import {repoAppBuilder} from '@github-ui/repo-app-builder'
import {mainQuery} from '@github-ui/react-core/future/main-query'
import type {ConversationRoutePayload} from './route-payload-types'
import {QueryRouteQueryType} from '@github-ui/react-core/future/data-router-types'
import {withOverviewParam} from './page-data-query'

export function buildPullRequestsConversationsRoute(appBuilder: DataRouterApplicationBuilder<string>) {
  return appBuilder.createQueryRouteConfig('pullRequestsConversationsRoute', {
    path: '/:owner/:repo/pull/:pr_number',
    queries: [
      mainQuery<ConversationRoutePayload>({
        queryDeps: ({pathname}) => ({pathname: withOverviewParam(pathname, false)}),
      }),
      railsPartialQuery({
        partialName: 'Body',
        queryDeps: ({pathname}) => {
          return {pathname: `${pathname}/partials/body`}
        },
      }),
      railsPartialQuery({
        partialName: 'Timeline',
        queryDeps: ({pathname}) => {
          return {pathname: `${pathname}/partials/timeline`}
        },
        type: QueryRouteQueryType.Deferred,
      }),
      railsPartialQuery({
        partialName: 'Sidebar',
        queryDeps: ({pathname}) => {
          return {pathname: `${pathname}/partials/sidebar`}
        },
        type: QueryRouteQueryType.Deferred,
      }),
      railsPartialQuery({
        partialName: 'TimelineActions',
        queryDeps: ({pathname}) => {
          return {pathname: `${pathname}/partials/timeline_actions`}
        },
      }),
    ],
    index: true,
  })
}

export const pullRequestsConversationsRoute = buildPullRequestsConversationsRoute(repoAppBuilder)
